import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';

import { Kurs } from "./../_models/kurs";

@Injectable()
export class KursService
{
  kurse: Kurs[];
  standorte: string[];
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string)
  {
    this.getKursStandorte().subscribe(x => this.standorte = x);
  }
  getKursStandorte()
  {
    return this.http.get<string[]>(this.baseUrl + 'api/kurs/getdistinct');
  }
  getKursById(id: number)
  {
    return this.http.get<Kurs>(this.baseUrl + 'api/kurs/' + id);
  }
  getKursByStandort(ort: string)
  {
    return this.http.get<Kurs[]>(this.baseUrl +"api/kurs/GetByStandort/"+ort)
  }
  getKurse()
  {
    return this.http.get<Kurs[]>(this.baseUrl + 'api/kurs');
  }
  getCoursesByTrainerToday(displayName: string) {
    return this.http.get<Kurs[]>(this.baseUrl + 'api/kurs/GetByTrainerToday/' + displayName);
  }
  getTrainerList() {
    return this.http.get<string[]>(this.baseUrl + 'users/getTrainer');
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/kurs.service.ts